//import { News } from '@benzinga/basic-news-manager';

export const MockNodes: any[] = [
  {
    assets: [
      {
        alt: "Agilent Likely To Report Lower Q4 Earnings; Here's A Look At Recent Price Target",
        attributes: {
          fid: '717545',
          filename: 'agilent_technologies_-_logo.jpg',
          filepath: 'files/images/story/2023/11/20/agilent_technologies_-_logo.jpg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: 'image/jpeg',
        primary: true,
        source: '',
        title: '',
        type: 'image',
      },
    ],
    author: 'Lisa Levin',
    channels: [
      {
        name: 'Earnings',
        tid: 16888,
        vid: 1,
      },
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Price Target',
        tid: 72,
        vid: 1,
      },
      {
        name: 'Markets',
        tid: 2,
        vid: 1,
      },
      {
        name: 'Analyst Ratings',
        tid: 67,
        vid: 1,
      },
      {
        name: 'Trading Ideas',
        tid: 22,
        vid: 1,
      },
    ],
    created: '2023-11-20T08:23:38Z',
    createdAt: '2023-11-20T08:23:38Z',
    id: 35867786,
    image: 'https://www.benzinga.com/files/images/story/2023/11/20/agilent_technologies_-_logo.jpg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Diagnostics & Research',
            IndustryCode: 20660010,
            IndustryGroup: 'Medical Diagnostics & Research',
            IndustryGroupCode: 20660,
            Sector: 'Healthcare',
            SectorCode: 206,
            SuperSector: 'Defensive',
            SuperSectorCode: 2,
          },
        ],
        NAICS: [
          {
            Industry: 'Navigational, Measuring, Electromedical, and Control Instruments Manufacturing',
            IndustryCode: 33451,
            IndustryGroup: 'Navigational, Measuring, Electromedical, and Control Instruments Manufacturing',
            IndustryGroupCode: 3345,
            NationalIndustry: 'Analytical Laboratory Instrument Manufacturing ',
            NationalIndustryCode: 334516,
            Sector: 'Manufacturing',
            SectorCode: 33,
            SubSector: 'Computer and Electronic Product Manufacturing',
            SubSectorCode: 334,
          },
        ],
        SIC: [
          {
            Division: '',
            Industry: 'Instruments For Measuring & Testing Of Electricity',
            IndustryCode: 3825,
            IndustryGroup: 382,
            MajorGroup: 38,
          },
        ],
      },
      wp_post_meta: null,
    },
    nodeId: 35867786,
    stocks: [
      {
        description: 'Agilent Technologies',
        name: 'A',
        primary: true,
        tid: 13498,
        vid: 2,
      },
    ],
    storyId: '655b174858a64d26a155a880',
    tags: [
      {
        name: 'Expert Ideas',
        tid: 868681,
        vid: 3,
      },
      {
        name: 'Most Accurate Analysts',
        tid: 859206,
        vid: 3,
      },
    ],
    teaser:
      'Agilent Technologies, Inc.  (NYSE: A) is projected to release financial results for the fourth quarter of fiscal year 2023, after the closing bell on Nov. 20, 2023.',
    teaserText:
      'Agilent Technologies, Inc.  (NYSE: A) is projected to release financial results for the fourth quarter of fiscal year 2023, after the closing bell on Nov. 20, 2023.',
    tickers: [
      {
        description: 'Agilent Technologies',
        name: 'A',
        primary: true,
        tid: 13498,
        vid: 2,
      },
    ],
    title:
      'Agilent Likely To Report Lower Q4 Earnings; Here&#39;s A Look At Recent Price Target Changes By The Most Accurate Analysts',
    updated: '2023-11-20T08:23:39Z',
    updatedAt: '2023-11-20T08:23:39Z',
    url: 'https://www.benzinga.com/news/earnings/23/11/35867786/agilent-likely-to-report-lower-q4-earnings-heres-a-look-at-recent-price-target-changes-by-the-most-',
  },
  {
    assets: [
      {
        alt: 'OpenAI Sam Altman',
        attributes: {
          fid: '717549',
          filename: 'Sam-altman-flickr_1.jpeg',
          filepath: 'files/images/story/2023/Sam-altman-flickr_1.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: 'image/jpeg',
        primary: true,
        source: 'Image: Flickr -  TechCrunch',
        title: 'Sam_altman_flickr',
        type: 'image',
      },
    ],
    author: 'Rounak Jain',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Top Stories',
        tid: 138079,
        vid: 1,
      },
      {
        name: 'Tech',
        tid: 6,
        vid: 1,
      },
    ],
    created: '2023-11-20T08:16:47Z',
    createdAt: '2023-11-20T08:16:47Z',
    id: 35867755,
    image: 'https://www.benzinga.com/files/images/story/2023/Sam-altman-flickr_1.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Software—Infrastructure',
            IndustryCode: 31110030,
            IndustryGroup: 'Software',
            IndustryGroupCode: 31110,
            Sector: 'Technology',
            SectorCode: 311,
            SuperSector: 'Sensitive',
            SuperSectorCode: 3,
          },
        ],
        NAICS: [
          {
            Industry: 'Software Publishers',
            IndustryCode: 51121,
            IndustryGroup: 'Software Publishers',
            IndustryGroupCode: 5112,
            NationalIndustry: 'Software Publishers',
            NationalIndustryCode: 511210,
            Sector: 'Information',
            SectorCode: 51,
            SubSector: 'Publishing Industries (except Internet)',
            SubSectorCode: 511,
          },
        ],
        SIC: [
          {
            Division: '',
            Industry: 'Prepackaged Software',
            IndustryCode: 7372,
            IndustryGroup: 737,
            MajorGroup: 73,
          },
        ],
      },
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 146091,
        post_path: 'tech/2023/11/20/sam-altman-greg-brockman-to-lead-a-new-advanced-ai-research-team-at-microsoft',
        post_type: 'post',
      },
    },
    nodeId: 35867755,
    stocks: [
      {
        description: 'Microsoft',
        name: 'MSFT',
        primary: true,
        tid: 12200,
        vid: 2,
      },
    ],
    storyId: '655b15f349547100018c5164',
    tags: [
      {
        name: 'artificial intelligence',
        tid: 131858,
        vid: 3,
      },
      {
        name: 'Consumer Tech',
        tid: 801154,
        vid: 3,
      },
      {
        name: 'Greg Brockman',
        tid: 888374,
        vid: 3,
      },
      {
        name: 'Microsoft',
        tid: 17660,
        vid: 3,
      },
      {
        name: 'OpenAi',
        tid: 596642,
        vid: 3,
      },
      {
        name: 'People In Tech',
        tid: 866690,
        vid: 3,
      },
      {
        name: 'Sam Altman',
        tid: 143402,
        vid: 3,
      },
      {
        name: 'Stories That Matter',
        tid: 913345,
        vid: 3,
      },
    ],
    teaser:
      'Sam Altman and Greg Brockman will lead a new advanced AI research team at Microsoft following their ouster from OpenAI.',
    teaserText:
      'Sam Altman and Greg Brockman will lead a new advanced AI research team at Microsoft following their ouster from OpenAI.',
    tickers: [
      {
        description: 'Microsoft',
        name: 'MSFT',
        primary: true,
        tid: 12200,
        vid: 2,
      },
    ],
    title: 'Sam Altman, Greg Brockman To Lead A New Advanced AI Research Team At Microsoft',
    updated: '2023-11-20T08:31:59Z',
    updatedAt: '2023-11-20T08:31:59Z',
    url: 'https://www.benzinga.com/news/23/11/35867755/sam-altman-greg-brockman-to-lead-a-new-advanced-ai-research-team-at-microsoft',
  },
  {
    assets: [
      {
        alt: 'Citigroup building logo',
        attributes: {
          fid: '717541',
          filename: 'citigroup-shutter2.jpeg',
          filepath: 'files/images/story/2023/citigroup-shutter2.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: '',
        title: 'citigroup shutter2',
        type: 'image',
      },
    ],
    author: 'Benzinga Neuro',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'General',
        tid: 18467,
        vid: 1,
      },
    ],
    created: '2023-11-20T08:13:16Z',
    createdAt: '2023-11-20T08:13:16Z',
    id: 35867733,
    image: 'https://www.benzinga.com/files/images/story/2023/citigroup-shutter2.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Banks—Diversified',
            IndustryCode: 10320010,
            IndustryGroup: 'Banks',
            IndustryGroupCode: 10320,
            Sector: 'Financial Services',
            SectorCode: 103,
            SuperSector: 'Cyclical',
            SuperSectorCode: 1,
          },
        ],
        NAICS: [
          {
            Industry: 'Commercial Banking ',
            IndustryCode: 52211,
            IndustryGroup: 'Depository Credit Intermediation ',
            IndustryGroupCode: 5221,
            NationalIndustry: 'Commercial Banking ',
            NationalIndustryCode: 522110,
            Sector: 'Finance and Insurance',
            SectorCode: 52,
            SubSector: 'Credit Intermediation and Related Activities',
            SubSectorCode: 522,
          },
        ],
        SIC: [
          {
            Division: '',
            Industry: 'National Commercial Banks',
            IndustryCode: 6021,
            IndustryGroup: 602,
            MajorGroup: 60,
          },
        ],
      },
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 146052,
        post_path: 'news/2023/11/20/citigroup-employees-brace-for-management-reshuffle-and-layoffs-on-monday-report',
        post_type: 'post',
      },
    },
    nodeId: 35867733,
    stocks: [
      {
        description: 'Citigroup Inc.',
        name: 'C',
        primary: true,
        tid: 13964,
        vid: 2,
      },
    ],
    storyId: '655b151849547100018c514e',
    tags: [
      {
        name: 'Citigroup',
        tid: 16830,
        vid: 3,
      },
      {
        name: 'layoff',
        tid: 774514,
        vid: 3,
      },
      {
        name: 'Stories That Matter',
        tid: 913345,
        vid: 3,
      },
    ],
    teaser:
      'The restructuring plans follow Citi&#39;s announcement last month of its intention to decrease management layers from 13 to eight.',
    teaserText:
      'The restructuring plans follow Citi&#39;s announcement last month of its intention to decrease management layers from 13 to eight.',
    tickers: [
      {
        description: 'Citigroup Inc.',
        name: 'C',
        primary: true,
        tid: 13964,
        vid: 2,
      },
    ],
    title: 'Citigroup Employees Brace For Management Reshuffle And Layoffs On Monday: Report',
    updated: '2023-11-20T08:13:16Z',
    updatedAt: '2023-11-20T08:13:16Z',
    url: 'https://www.benzinga.com/news/23/11/35867733/citigroup-employees-brace-for-management-reshuffle-and-layoffs-on-monday-report',
  },
  {
    assets: [
      {
        alt: 'Trump Photo by a katz on Shutterstock',
        attributes: {
          fid: '717538',
          filename: 'Trump-Photo-by-a-katz-on-Shutterstock.jpeg',
          filepath: 'files/images/story/2023/Trump-Photo-by-a-katz-on-Shutterstock.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Trump Photo by a katz on Shutterstock',
        title: 'Trump Photo by a katz on Shutterstock',
        type: 'image',
      },
    ],
    author: 'Navdeep Yadav',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Politics',
        tid: 16779,
        vid: 1,
      },
      {
        name: 'General',
        tid: 18467,
        vid: 1,
      },
    ],
    created: '2023-11-20T08:04:54Z',
    createdAt: '2023-11-20T08:04:54Z',
    id: 35867670,
    image: 'https://www.benzinga.com/files/images/story/2023/Trump-Photo-by-a-katz-on-Shutterstock.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: true,
        SendToMSN: false,
        SendToRobinhood: false,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 146008,
        post_path: 'news/2023/11/20/donald-trump-opens-up-about-melanias-response-to-golden-showers-allegations',
        post_type: 'post',
      },
    },
    nodeId: 35867670,
    stocks: [],
    storyId: '655b131b49547100018c510f',
    tags: [
      {
        name: '2024 Presidential Race',
        tid: 847292,
        vid: 3,
      },
      {
        name: 'Donald Trump',
        tid: 18656,
        vid: 3,
      },
      {
        name: 'Iowa rally',
        tid: 915609,
        vid: 3,
      },
      {
        name: 'Melania Trump',
        tid: 597998,
        vid: 3,
      },
    ],
    teaser:
      'Former President Donald Trump, during the recent Iowa rally, shared Melania Trump&#39;s response to the notorious &#34;golden showers&#34; allegations.',
    teaserText:
      'Former President Donald Trump, during the recent Iowa rally, shared Melania Trump&#39;s response to the notorious &#34;golden showers&#34; allegations.',
    tickers: [],
    title:
      'Donald Trump Opens Up About Melania&#39;s Response To Controversial Allegations About His Personal Life: &#39;It&#39;s Not True, Darling. I Love You Very Much.&#39;',
    updated: '2023-11-20T08:04:55Z',
    updatedAt: '2023-11-20T08:04:55Z',
    url: 'https://www.benzinga.com/news/23/11/35867670/donald-trump-opens-up-about-melanias-response-to-controversial-allegations-about-his-personal-life-i',
  },
  {
    assets: [
      {
        alt: 'Inflation, disinflation',
        attributes: {
          fid: '717537',
          filename: 'Inflation_2.jpeg',
          filepath: 'files/images/story/2023/Inflation_2.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Inflation illustration. Photo via Shutterstock. ',
        title: 'Inflation',
        type: 'image',
      },
    ],
    author: 'Benzinga Neuro',
    channels: [
      {
        name: 'Analyst Color',
        tid: 68,
        vid: 1,
      },
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Economics',
        tid: 17375,
        vid: 1,
      },
      {
        name: 'Federal Reserve',
        tid: 125743,
        vid: 1,
      },
      {
        name: 'Markets',
        tid: 2,
        vid: 1,
      },
    ],
    created: '2023-11-20T08:03:56Z',
    createdAt: '2023-11-20T08:03:56Z',
    id: 35867664,
    image: 'https://www.benzinga.com/files/images/story/2023/Inflation_2.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 146021,
        post_path:
          'analyst-ratings/analyst-color/2023/11/20/legendary-economist-foresees-30-drop-in-stocks-predicts-recession-and-feds-credibility-issue',
        post_type: 'post',
      },
    },
    nodeId: 35867664,
    stocks: [],
    storyId: '655b12e849547100018c5109',
    tags: [
      {
        name: 'Federal Reserve',
        tid: 17084,
        vid: 3,
      },
      {
        name: 'Gary Shilling',
        tid: 19727,
        vid: 3,
      },
      {
        name: 'Inflation',
        tid: 17810,
        vid: 3,
      },
      {
        name: 'Stories That Matter',
        tid: 913345,
        vid: 3,
      },
    ],
    teaser:
      'Shilling asserted that the Federal Reserve was late in addressing inflation, leading to a credibility issue.',
    teaserText:
      'Shilling asserted that the Federal Reserve was late in addressing inflation, leading to a credibility issue.',
    tickers: [],
    title:
      'Legendary Economist Foresees 30% Drop In Stocks, Predicts Recession And Fed&#39;s &#39;Credibility&#39; Issue',
    updated: '2023-11-20T08:03:56Z',
    updatedAt: '2023-11-20T08:03:56Z',
    url: 'https://www.benzinga.com/analyst-ratings/analyst-color/23/11/35867664/legendary-economist-foresees-30-drop-in-stocks-predicts-recession-and-feds-credibil',
  },
  {
    assets: [
      {
        alt: 'Instagram Photo by rafapress on Shutterstock',
        attributes: {
          fid: '717536',
          filename: 'Instagram-Photo-by-rafapress-on-Shutters.jpeg',
          filepath: 'files/images/story/2023/Instagram-Photo-by-rafapress-on-Shutters.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Instagram Photo by rafapress on Shutterstock',
        title: 'Instagram Photo by rafapress on Shutterstock',
        type: 'image',
      },
    ],
    author: 'Benzinga Neuro',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        description: 'Social Media',
        name: 'Social Media',
        tid: 831971,
        vid: 1,
      },
      {
        name: 'Tech',
        tid: 6,
        vid: 1,
      },
      {
        name: 'General',
        tid: 18467,
        vid: 1,
      },
    ],
    created: '2023-11-20T07:59:51Z',
    createdAt: '2023-11-20T07:59:51Z',
    id: 35867623,
    image: 'https://www.benzinga.com/files/images/story/2023/Instagram-Photo-by-rafapress-on-Shutters.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145981,
        post_path:
          'general/social-media/2023/11/20/meta-whistleblower-alleges-that-his-repeated-warnings-to-mark-zuckerberg-about-teen-safety-issues-on-instagram-were-ignored',
        post_type: 'post',
      },
    },
    nodeId: 35867623,
    stocks: [],
    storyId: '655b11eb49547100018c50e2',
    tags: [
      {
        name: 'Arturo Bejar',
        tid: 915607,
        vid: 3,
      },
      {
        name: 'Consumer Tech',
        tid: 801154,
        vid: 3,
      },
      {
        name: 'Instagram',
        tid: 66071,
        vid: 3,
      },
      {
        name: 'Meta',
        tid: 127609,
        vid: 3,
      },
      {
        name: 'Molly Russell',
        tid: 915608,
        vid: 3,
      },
      {
        name: 'Stories That Matter',
        tid: 913345,
        vid: 3,
      },
    ],
    teaser:
      'The whistleblower challenged Instagram&#39;s policies, questioning the percentage of Molly&#39;s saved content that was in violation. ',
    teaserText:
      'The whistleblower challenged Instagram&#39;s policies, questioning the percentage of Molly&#39;s saved content that was in violation. ',
    tickers: [],
    title:
      'Meta Whistleblower Alleges That His Repeated Warnings To Mark Zuckerberg About Teen Safety Issues On Instagram Were Ignored',
    updated: '2023-11-20T07:59:52Z',
    updatedAt: '2023-11-20T07:59:52Z',
    url: 'https://www.benzinga.com/news/23/11/35867623/meta-whistleblower-alleges-that-his-repeated-warnings-to-mark-zuckerberg-about-teen-safety-issues-on',
  },
  {
    assets: [
      {
        alt: 'Elon Musk Photo by Frederic Legrand - COMEO on Shutterstock',
        attributes: {
          fid: '717535',
          filename: 'Elon-Musk-Photo-by-Frederic-Legrand---CO_4.jpeg',
          filepath: 'files/images/story/2023/Elon-Musk-Photo-by-Frederic-Legrand---CO_4.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Elon Musk Photo by Frederic Legrand - COMEO on Shutterstock ',
        title: 'Elon Musk Photo by Frederic Legrand - COMEO on Shutterstock',
        type: 'image',
      },
    ],
    author: 'Shanthi Rexaline',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Management',
        tid: 60,
        vid: 1,
      },
      {
        name: 'Top Stories',
        tid: 138079,
        vid: 1,
      },
      {
        name: 'Tech',
        tid: 6,
        vid: 1,
      },
    ],
    created: '2023-11-20T07:58:44Z',
    createdAt: '2023-11-20T07:58:44Z',
    id: 35867612,
    image: 'https://www.benzinga.com/files/images/story/2023/Elon-Musk-Photo-by-Frederic-Legrand---CO_4.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Software—Infrastructure',
            IndustryCode: 31110030,
            IndustryGroup: 'Software',
            IndustryGroupCode: 31110,
            Sector: 'Technology',
            SectorCode: 311,
            SuperSector: 'Sensitive',
            SuperSectorCode: 3,
          },
        ],
        NAICS: [
          {
            Industry: 'Software Publishers',
            IndustryCode: 51121,
            IndustryGroup: 'Software Publishers',
            IndustryGroupCode: 5112,
            NationalIndustry: 'Software Publishers',
            NationalIndustryCode: 511210,
            Sector: 'Information',
            SectorCode: 51,
            SubSector: 'Publishing Industries (except Internet)',
            SubSectorCode: 511,
          },
        ],
        SIC: [
          {
            Division: '',
            Industry: 'Prepackaged Software',
            IndustryCode: 7372,
            IndustryGroup: 737,
            MajorGroup: 73,
          },
        ],
      },
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 146019,
        post_path:
          'news/management/2023/11/20/elon-musk-very-worried-about-openai-boardroom-battle-ilya-sutskever-wouldnt-take-such-drastic-action-unless-absolutely-necessary',
        post_type: 'post',
      },
    },
    nodeId: 35867612,
    stocks: [
      {
        description: 'Microsoft',
        name: 'MSFT',
        primary: true,
        tid: 12200,
        vid: 2,
      },
    ],
    storyId: '655b11aa49547100018c50d7',
    tags: [
      {
        name: 'Elon Musk',
        tid: 30461,
        vid: 3,
      },
      {
        name: 'Ilya Sutskever',
        tid: 915606,
        vid: 3,
      },
      {
        name: 'OpenAi',
        tid: 596642,
        vid: 3,
      },
    ],
    teaser:
      'Tesla CEO Elon Musk on Sunday suggested he is worried about the potential reasons behind the boardroom battle at OpenAI.',
    teaserText:
      'Tesla CEO Elon Musk on Sunday suggested he is worried about the potential reasons behind the boardroom battle at OpenAI.',
    tickers: [
      {
        description: 'Microsoft',
        name: 'MSFT',
        primary: true,
        tid: 12200,
        vid: 2,
      },
    ],
    title:
      'Elon Musk &#39;Very Worried&#39; About OpenAI Boardroom Battle; Ilya Sutskever &#39;Wouldn&#39;t Take Such Drastic Action Unless.. Absolutely Necessary&#39;',
    updated: '2023-11-20T07:58:45Z',
    updatedAt: '2023-11-20T07:58:45Z',
    url: 'https://www.benzinga.com/news/23/11/35867612/elon-musk-very-worried-about-openai-boardroom-battle-ilya-sutskever-wouldnt-take-such-drastic-action',
  },
  {
    assets: [
      {
        alt: 'Nio EV',
        attributes: {
          fid: '717496',
          filename: 'Wuhan-china-may-2021-Nio-Brand-Logo-With.jpeg',
          filepath: 'files/images/story/2023/Wuhan-china-may-2021-Nio-Brand-Logo-With.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: '',
        title: 'Wuhan.china-may,2021:,Nio,Brand,Logo,With,Electric,Car,In,Store.',
        type: 'image',
      },
    ],
    author: 'Anan Ashraf',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Tech',
        tid: 6,
        vid: 1,
      },
    ],
    created: '2023-11-20T07:49:17Z',
    createdAt: '2023-11-20T07:49:17Z',
    id: 35867543,
    image: 'https://www.benzinga.com/files/images/story/2023/Wuhan-china-may-2021-Nio-Brand-Logo-With.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Auto Manufacturers',
            IndustryCode: 10200020,
            IndustryGroup: 'Vehicles & Parts',
            IndustryGroupCode: 10200,
            Sector: 'Consumer Cyclical',
            SectorCode: 102,
            SuperSector: 'Cyclical',
            SuperSectorCode: 1,
          },
        ],
      },
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145985,
        post_path:
          'tech/2023/11/20/nios-future-secure-says-co-founder-company-sees-significant-delivery-growth-despite-market-speculation',
        post_type: 'post',
      },
    },
    nodeId: 35867543,
    stocks: [
      {
        description: 'NIO',
        name: 'NIO',
        primary: true,
        tid: 755463,
        vid: 2,
      },
    ],
    storyId: '655b0f7a49547100018c5096',
    tags: [
      {
        name: 'electric vehicles',
        tid: 29684,
        vid: 3,
      },
      {
        name: 'EVs',
        tid: 34765,
        vid: 3,
      },
      {
        name: 'mobility',
        tid: 714582,
        vid: 3,
      },
      {
        name: 'Qin Lihong',
        tid: 801318,
        vid: 3,
      },
    ],
    teaser:
      'Nio Inc&#39;s co-founder Qin Lihong refuted rumors of the Chinese EV maker going out of business. Oct deliveries up 40%.',
    teaserText:
      'Nio Inc&#39;s co-founder Qin Lihong refuted rumors of the Chinese EV maker going out of business. Oct deliveries up 40%.',
    tickers: [
      {
        description: 'NIO',
        name: 'NIO',
        primary: true,
        tid: 755463,
        vid: 2,
      },
    ],
    title:
      'Nio&#39;s Future Secure, Says Co-founder: Company Sees Significant Delivery Growth Despite Market Speculation',
    updated: '2023-11-20T07:49:18Z',
    updatedAt: '2023-11-20T07:49:18Z',
    url: 'https://www.benzinga.com/news/23/11/35867543/nios-future-secure-says-co-founder-company-sees-significant-delivery-growth-despite-market-speculati',
  },
  {
    assets: [
      {
        alt: 'Dog Photo by SakSa on Shutterstock',
        attributes: {
          fid: '717495',
          filename: 'Dog-Photo-by-SakSa-on-Shutterstock.jpeg',
          filepath: 'files/images/story/2023/Dog-Photo-by-SakSa-on-Shutterstock.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: 'image/jpeg',
        primary: true,
        source: 'Dog Photo by SakSa on Shutterstock',
        title: 'Dog Photo by SakSa on Shutterstock',
        type: 'image',
      },
    ],
    author: 'Benzinga Neuro',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Health Care',
        tid: 140295,
        vid: 1,
      },
      {
        name: 'General',
        tid: 18467,
        vid: 1,
      },
    ],
    created: '2023-11-20T07:41:23Z',
    createdAt: '2023-11-20T07:41:23Z',
    id: 35867512,
    image: 'https://www.benzinga.com/files/images/story/2023/Dog-Photo-by-SakSa-on-Shutterstock.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145961,
        post_path:
          'general/health-care/2023/11/20/mysterious-canine-respiratory-ailment-affects-dogs-in-various-us-states',
        post_type: 'post',
      },
    },
    nodeId: 35867512,
    stocks: [],
    storyId: '655b0d9849547100018c5079',
    tags: [
      {
        name: 'dogs',
        tid: 31517,
        vid: 3,
      },
      {
        name: 'Respiratory disease',
        tid: 915605,
        vid: 3,
      },
      {
        name: 'US',
        tid: 19057,
        vid: 3,
      },
    ],
    teaser:
      'Dogs suffering from the disease are experiencing symptoms such as coughing, sneezing, nasal or eye discharge, and lethargy.',
    teaserText:
      'Dogs suffering from the disease are experiencing symptoms such as coughing, sneezing, nasal or eye discharge, and lethargy.',
    tickers: [],
    title: 'Mysterious Canine Respiratory Ailment Affects Dogs In Various US States',
    updated: '2023-11-20T07:41:23Z',
    updatedAt: '2023-11-20T07:41:23Z',
    url: 'https://www.benzinga.com/news/23/11/35867512/mysterious-canine-respiratory-ailment-affects-dogs-in-various-us-states',
  },
  {
    assets: [
      {
        alt: 'Cryptocurrency Photo by Matt Benzero on Shutterstock',
        attributes: {
          fid: '717494',
          filename: 'Cryptocurrency-Photo-by-Matt-Benzero-on-.jpeg',
          filepath: 'files/images/story/2023/Cryptocurrency-Photo-by-Matt-Benzero-on-.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Cryptocurrency Photo by Matt Benzero on Shutterstock',
        title: 'Cryptocurrency Photo by Matt Benzero on Shutterstock',
        type: 'image',
      },
    ],
    author: 'Mehab Qureshi',
    channels: [
      {
        description: 'Coverage of Bitcoin, Etherum, Ripple and all the latest digital currencies.',
        name: 'Cryptocurrency',
        tid: 135733,
        vid: 1,
      },
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Markets',
        tid: 2,
        vid: 1,
      },
    ],
    created: '2023-11-20T07:38:35Z',
    createdAt: '2023-11-20T07:38:35Z',
    id: 35867498,
    image: 'https://www.benzinga.com/files/images/story/2023/Cryptocurrency-Photo-by-Matt-Benzero-on-.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 146030,
        post_path:
          'markets/cryptocurrency/2023/11/20/this-meme-coin-skyrocketed-2000-in-2023-leaving-dogecoin-shiba-inu-behind',
        post_type: 'post',
      },
    },
    nodeId: 35867498,
    stocks: [
      {
        description: 'Dogecoin - United States Dollar',
        name: '$DOGE',
        tid: 797639,
        vid: 2,
      },
      {
        description: 'PEPE',
        name: '$PEPE',
        tid: 893850,
        vid: 2,
      },
      {
        description: 'Shiba Inu',
        name: '$SHIB',
        primary: true,
        tid: 807085,
        vid: 2,
      },
    ],
    storyId: '655b0cf649547100018c506c',
    tags: [
      {
        name: 'dogecoin',
        tid: 134390,
        vid: 3,
      },
      {
        name: 'Pepe Coin',
        tid: 895096,
        vid: 3,
      },
      {
        name: 'Shiba Inu',
        tid: 801315,
        vid: 3,
      },
    ],
    teaser:
      'Pepe coin (CRYPTO: PEPE) has taken the spotlight with a year-to-date price increase of 2000%, outperforming top meme cryptocurrencies such as Dogecoin (CRYPTO: DOGE) and Shiba Inu (CRYPTO: ',
    teaserText:
      'Pepe coin (CRYPTO: PEPE) has taken the spotlight with a year-to-date price increase of 2000%, outperforming top meme cryptocurrencies such as Dogecoin (CRYPTO: DOGE) and Shiba Inu (CRYPTO: ',
    tickers: [
      {
        description: 'Dogecoin - United States Dollar',
        name: '$DOGE',
        tid: 797639,
        vid: 2,
      },
      {
        description: 'PEPE',
        name: '$PEPE',
        tid: 893850,
        vid: 2,
      },
      {
        description: 'Shiba Inu',
        name: '$SHIB',
        primary: true,
        tid: 807085,
        vid: 2,
      },
    ],
    title: 'This Meme Coin Skyrocketed 2000% In 2023, Leaving Dogecoin, Shiba Inu Behind',
    updated: '2023-11-20T07:38:36Z',
    updatedAt: '2023-11-20T07:38:36Z',
    url: 'https://www.benzinga.com/markets/cryptocurrency/23/11/35867498/this-meme-coin-skyrocketed-2000-in-2023-leaving-dogecoin-shiba-inu-behind',
  },
  {
    assets: [
      {
        alt: 'Peter Thiel wikimedia commons',
        attributes: {
          fid: '717493',
          filename: 'Peter-Thiel-wikimedia-commons.jpeg',
          filepath: 'files/images/story/2023/Peter-Thiel-wikimedia-commons.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Peter Thiel wikimedia commons',
        title: 'Peter Thiel wikimedia commons',
        type: 'image',
      },
    ],
    author: 'Anan Ashraf',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Tech',
        tid: 6,
        vid: 1,
      },
    ],
    created: '2023-11-20T07:22:21Z',
    createdAt: '2023-11-20T07:22:21Z',
    id: 35867416,
    image: 'https://www.benzinga.com/files/images/story/2023/Peter-Thiel-wikimedia-commons.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Auto Manufacturers',
            IndustryCode: 10200020,
            IndustryGroup: 'Vehicles & Parts',
            IndustryGroupCode: 10200,
            Sector: 'Consumer Cyclical',
            SectorCode: 102,
            SuperSector: 'Cyclical',
            SuperSectorCode: 1,
          },
        ],
        NAICS: [
          {
            Industry: 'Motor Vehicle Body and Trailer Manufacturing',
            IndustryCode: 33621,
            IndustryGroup: 'Motor Vehicle Body and Trailer Manufacturing',
            IndustryGroupCode: 3362,
            NationalIndustry: 'Motor Vehicle Body Manufacturing ',
            NationalIndustryCode: 336211,
            Sector: 'Manufacturing',
            SectorCode: 33,
            SubSector: 'Transportation Equipment Manufacturing',
            SubSectorCode: 336,
          },
        ],
        SIC: [
          {
            Division: '',
            Industry: 'Motor Vehicles & Passenger Car Bodies',
            IndustryCode: 3711,
            IndustryGroup: 371,
            MajorGroup: 37,
          },
        ],
      },
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145917,
        post_path: '2023/11/20/elon-musk-refutes-thiels-law-says-thiel-refused-to-fund-tesla-at-onset',
        post_type: 'post',
      },
    },
    nodeId: 35867416,
    stocks: [
      {
        description: 'Tesla Motors',
        name: 'TSLA',
        primary: true,
        tid: 26160,
        vid: 2,
      },
    ],
    storyId: '655b092a49547100018c501b',
    tags: [
      {
        name: 'electric vehicles',
        tid: 29684,
        vid: 3,
      },
      {
        name: 'Elon Musk',
        tid: 30461,
        vid: 3,
      },
      {
        name: 'EVs',
        tid: 34765,
        vid: 3,
      },
      {
        name: 'mobility',
        tid: 714582,
        vid: 3,
      },
      {
        name: 'Peter Thiel',
        tid: 26045,
        vid: 3,
      },
    ],
    teaser: ' ',
    teaserText: ' ',
    tickers: [
      {
        description: 'Tesla Motors',
        name: 'TSLA',
        primary: true,
        tid: 26160,
        vid: 2,
      },
    ],
    title: 'Elon Musk Refutes PayPal Co-Founder&#39;s &#39;Law,&#39; Claims Peter Thiel Refused to Fund Tesla at Onset',
    updated: '2023-11-20T07:22:22Z',
    updatedAt: '2023-11-20T07:22:22Z',
    url: 'https://www.benzinga.com/news/23/11/35867416/elon-musk-refutes-paypal-co-founders-law-claims-peter-thiel-refused-to-fund-tesla-at-onset',
  },
  {
    assets: [
      {
        alt: 'ChatGPT Maker OpenAI In Hot Waters With FTC And High-Profile Lawsuit',
        attributes: {
          fid: '717492',
          filename: 'ChatGPT-OpenAI-Shutterstock_0.jpeg',
          filepath: 'files/images/story/2023/ChatGPT-OpenAI-Shutterstock_0.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: 'image/jpeg',
        primary: true,
        source: '',
        title: 'ChatGPT.OpenAI.Shutterstock',
        type: 'image',
      },
    ],
    author: 'Shanthi Rexaline',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Management',
        tid: 60,
        vid: 1,
      },
      {
        name: 'Top Stories',
        tid: 138079,
        vid: 1,
      },
      {
        name: 'Tech',
        tid: 6,
        vid: 1,
      },
      {
        name: 'Media',
        tid: 5,
        vid: 1,
      },
    ],
    created: '2023-11-20T07:15:27Z',
    createdAt: '2023-11-20T07:15:27Z',
    id: 35867389,
    image: 'https://www.benzinga.com/files/images/story/2023/ChatGPT-OpenAI-Shutterstock_0.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Software—Infrastructure',
            IndustryCode: 31110030,
            IndustryGroup: 'Software',
            IndustryGroupCode: 31110,
            Sector: 'Technology',
            SectorCode: 311,
            SuperSector: 'Sensitive',
            SuperSectorCode: 3,
          },
        ],
        NAICS: [
          {
            Industry: 'Software Publishers',
            IndustryCode: 51121,
            IndustryGroup: 'Software Publishers',
            IndustryGroupCode: 5112,
            NationalIndustry: 'Software Publishers',
            NationalIndustryCode: 511210,
            Sector: 'Information',
            SectorCode: 51,
            SubSector: 'Publishing Industries (except Internet)',
            SubSectorCode: 511,
          },
        ],
        SIC: [
          {
            Division: '',
            Industry: 'Prepackaged Software',
            IndustryCode: 7372,
            IndustryGroup: 737,
            MajorGroup: 73,
          },
        ],
      },
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145992,
        post_path:
          'news/management/2023/11/20/openai-saga-plays-out-3-ceos-in-3-days-as-mira-muratis-efforts-to-reinstate-sam-altman-fall-through-board-names-new-ceo',
        post_type: 'post',
      },
    },
    nodeId: 35867389,
    stocks: [
      {
        description: 'Microsoft',
        name: 'MSFT',
        primary: true,
        tid: 12200,
        vid: 2,
      },
    ],
    storyId: '655b078449547100018c5003',
    tags: [
      {
        name: 'Adam D’Angelo',
        tid: 915604,
        vid: 3,
      },
      {
        name: 'emmett shear',
        tid: 915603,
        vid: 3,
      },
      {
        name: 'Greg Brockman',
        tid: 888374,
        vid: 3,
      },
      {
        name: 'Sam Altman',
        tid: 143402,
        vid: 3,
      },
    ],
    teaser:
      'OpenAI&#39;s board named former Twitch CEO as its new top brass after interim CEO Mira Murati aligned with Sam Altman, reports say.',
    teaserText:
      'OpenAI&#39;s board named former Twitch CEO as its new top brass after interim CEO Mira Murati aligned with Sam Altman, reports say.',
    tickers: [
      {
        description: 'Microsoft',
        name: 'MSFT',
        primary: true,
        tid: 12200,
        vid: 2,
      },
    ],
    title:
      'OpenAI Saga Plays Out: 3 CEOs In 3 Days As Mira Murati&#39;s Efforts To Reinstate Sam Altman Fall Through — Board Names New CEO',
    updated: '2023-11-20T07:15:28Z',
    updatedAt: '2023-11-20T07:15:28Z',
    url: 'https://www.benzinga.com/news/23/11/35867389/openai-saga-plays-out-3-ceos-in-3-days-as-mira-muratis-efforts-to-reinstate-sam-altman-fall-through',
  },
  {
    assets: [
      {
        alt: 'Tesla CEO Elon Musk',
        attributes: {
          fid: '717489',
          filename: 'Tesla-CEO-Elon-Musk.jpeg',
          filepath: 'files/images/story/2023/Tesla-CEO-Elon-Musk.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Illustration by Geena123 on Shutterstock',
        title: 'Tesla CEO Elon Musk',
        type: 'image',
      },
    ],
    author: 'Shanthi Rexaline',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        description: 'Social Media',
        name: 'Social Media',
        tid: 831971,
        vid: 1,
      },
      {
        name: 'Top Stories',
        tid: 138079,
        vid: 1,
      },
      {
        name: 'Media',
        tid: 5,
        vid: 1,
      },
    ],
    created: '2023-11-20T06:40:57Z',
    createdAt: '2023-11-20T06:40:57Z',
    id: 35867232,
    image: 'https://www.benzinga.com/files/images/story/2023/Tesla-CEO-Elon-Musk.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {
        Morningstar: [
          {
            Industry: 'Auto Manufacturers',
            IndustryCode: 10200020,
            IndustryGroup: 'Vehicles & Parts',
            IndustryGroupCode: 10200,
            Sector: 'Consumer Cyclical',
            SectorCode: 102,
            SuperSector: 'Cyclical',
            SuperSectorCode: 1,
          },
        ],
        NAICS: [
          {
            Industry: 'Motor Vehicle Body and Trailer Manufacturing',
            IndustryCode: 33621,
            IndustryGroup: 'Motor Vehicle Body and Trailer Manufacturing',
            IndustryGroupCode: 3362,
            NationalIndustry: 'Motor Vehicle Body Manufacturing ',
            NationalIndustryCode: 336211,
            Sector: 'Manufacturing',
            SectorCode: 33,
            SubSector: 'Transportation Equipment Manufacturing',
            SubSectorCode: 336,
          },
        ],
        SIC: [
          {
            Division: '',
            Industry: 'Motor Vehicles & Passenger Car Bodies',
            IndustryCode: 3711,
            IndustryGroup: 371,
            MajorGroup: 37,
          },
        ],
      },
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145957,
        post_path:
          'general/social-media/2023/11/20/elon-musk-survives-despite-ongoing-career-death-watch-says-management-guru-will-the-billionaire-feel-the-peril-of-anti-semitism-controversy',
        post_type: 'post',
      },
    },
    nodeId: 35867232,
    stocks: [
      {
        description: 'Tesla Motors',
        name: 'TSLA',
        primary: true,
        tid: 26160,
        vid: 2,
      },
    ],
    storyId: '655aff7549547100018c4f6b',
    tags: [
      {
        name: 'Elon Musk',
        tid: 30461,
        vid: 3,
      },
      {
        name: 'Eric Dezenhall',
        tid: 146515,
        vid: 3,
      },
      {
        name: 'Linda Yaccarino',
        tid: 896530,
        vid: 3,
      },
    ],
    teaser: ' ',
    teaserText: ' ',
    tickers: [
      {
        description: 'Tesla Motors',
        name: 'TSLA',
        primary: true,
        tid: 26160,
        vid: 2,
      },
    ],
    title:
      'Elon Musk Survives Despite &#39;Ongoing Career Death Watch,&#39; Says Management Guru: Will The Billionaire Feel The Peril Of Anti-Semitism Controversy?',
    updated: '2023-11-20T06:40:57Z',
    updatedAt: '2023-11-20T06:40:57Z',
    url: 'https://www.benzinga.com/news/23/11/35867232/elon-musk-survives-despite-ongoing-career-death-watch-says-management-guru-will-the-billionaire-feel',
  },
  {
    assets: [
      {
        alt: 'ElonMusk.X.Shutterstock',
        attributes: {
          fid: '717483',
          filename: 'ElonMusk-X-Shutterstock.jpeg',
          filepath: 'files/images/story/2023/ElonMusk-X-Shutterstock.jpeg',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: '',
        title: 'ElonMusk.X.Shutterstock',
        type: 'image',
      },
    ],
    author: 'Benzinga Neuro',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Tech',
        tid: 6,
        vid: 1,
      },
      {
        name: 'General',
        tid: 18467,
        vid: 1,
      },
    ],
    created: '2023-11-20T05:01:32Z',
    createdAt: '2023-11-20T05:01:32Z',
    id: 35866912,
    image: 'https://www.benzinga.com/files/images/story/2023/ElonMusk-X-Shutterstock.jpeg',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145905,
        post_path:
          'tech/2023/11/20/elon-musks-mutiny-fears-led-to-ban-on-large-meetings-at-x-reveals-breaking-twitter-author-spiraling-out-of-control',
        post_type: 'post',
      },
    },
    nodeId: 35866912,
    stocks: [],
    storyId: '655ae82149547100018c4e39',
    tags: [
      {
        name: 'Breaking Twitter',
        tid: 915600,
        vid: 3,
      },
      {
        name: 'Consumer Tech',
        tid: 801154,
        vid: 3,
      },
      {
        name: 'Elon Musk',
        tid: 30461,
        vid: 3,
      },
      {
        name: 'Stories That Matter',
        tid: 913345,
        vid: 3,
      },
      {
        name: 'twitter',
        tid: 17627,
        vid: 3,
      },
      {
        name: 'X',
        tid: 673658,
        vid: 3,
      },
    ],
    teaser:
      'The author also suggested that Musk&#39;s concerns were not entirely unfounded as a faction of employees were contemplating a mass resignation. ',
    teaserText:
      'The author also suggested that Musk&#39;s concerns were not entirely unfounded as a faction of employees were contemplating a mass resignation. ',
    tickers: [],
    title:
      'Elon Musk&#39;s &#39;Mutiny&#39; Fears Led To Ban On Large Meetings At X, Reveals &#39;Breaking Twitter&#39; Author: &#39;Spiraling Out Of Control&#39;',
    updated: '2023-11-20T05:01:33Z',
    updatedAt: '2023-11-20T05:01:33Z',
    url: 'https://www.benzinga.com/news/23/11/35866912/elon-musks-mutiny-fears-led-to-ban-on-large-meetings-at-x-reveals-breaking-twitter-author-spiraling',
  },
  {
    assets: [
      {
        alt: 'Javier Milei Image Via Wikimedia Commons',
        attributes: {
          fid: '717482',
          filename: 'Javier-Milei_0.png',
          filepath: 'files/images/story/2023/Javier-Milei_0.png',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Javier Milei Image Via Wikimedia Commons',
        title: 'Javier Milei',
        type: 'image',
      },
    ],
    author: 'Mehab Qureshi',
    channels: [
      {
        description: 'Coverage of Bitcoin, Etherum, Ripple and all the latest digital currencies.',
        name: 'Cryptocurrency',
        tid: 135733,
        vid: 1,
      },
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Markets',
        tid: 2,
        vid: 1,
      },
    ],
    created: '2023-11-20T04:41:05Z',
    createdAt: '2023-11-20T04:41:05Z',
    id: 35866865,
    image: 'https://www.benzinga.com/files/images/story/2023/Javier-Milei_0.png',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145899,
        post_path:
          'markets/cryptocurrency/2023/11/20/dogecoin-co-creator-thinks-javier-milei-is-cool-and-doge-father-musk-believes-prosperity-is-ahead-for-argentina',
        post_type: 'post',
      },
    },
    nodeId: 35866865,
    stocks: [
      {
        description: 'Bitcoin - United States Dollar',
        name: '$BTC',
        primary: true,
        tid: 764552,
        vid: 2,
      },
      {
        description: 'Dogecoin - United States Dollar',
        name: '$DOGE',
        primary: true,
        tid: 797639,
        vid: 2,
      },
    ],
    storyId: '655ae35b49547100018c4e0d',
    tags: [
      {
        name: 'Billy Markus',
        tid: 793316,
        vid: 3,
      },
      {
        name: 'Bitcoin',
        tid: 41516,
        vid: 3,
      },
      {
        name: 'dogecoin',
        tid: 134390,
        vid: 3,
      },
      {
        name: 'javier milei',
        tid: 840327,
        vid: 3,
      },
      {
        name: 'Sergio Massa',
        tid: 851946,
        vid: 3,
      },
    ],
    teaser:
      'Elon Musk believes “prosperity is ahead” for Argentina after Bitcoin (CRYPTO: BTC) friendly candidate Javier Milei officially won ',
    teaserText:
      'Elon Musk believes “prosperity is ahead” for Argentina after Bitcoin (CRYPTO: BTC) friendly candidate Javier Milei officially won ',
    tickers: [
      {
        description: 'Bitcoin - United States Dollar',
        name: '$BTC',
        primary: true,
        tid: 764552,
        vid: 2,
      },
      {
        description: 'Dogecoin - United States Dollar',
        name: '$DOGE',
        primary: true,
        tid: 797639,
        vid: 2,
      },
    ],
    title:
      'Dogecoin Co-Creator Thinks Javier Milei Is Cool And &#39;DOGE Father&#39; Musk Believes &#39;Prosperity Is Ahead&#39; For Argentina',
    updated: '2023-11-20T04:41:06Z',
    updatedAt: '2023-11-20T04:41:06Z',
    url: 'https://www.benzinga.com/markets/cryptocurrency/23/11/35866865/dogecoin-co-creator-thinks-javier-milei-is-cool-and-doge-father-musk-believes-prosperity-i',
  },
  {
    assets: [
      {
        alt: 'Trump vs DeSantis',
        attributes: {
          fid: '717480',
          filename: 'Trump-vs-DeSantis_0.png',
          filepath: 'files/images/story/2023/Trump-vs-DeSantis_0.png',
          filesize: 0,
          image_attributes: {
            resolution: {
              dpi: 0,
              height: 0,
              width: 0,
            },
          },
        },
        mime: '',
        primary: true,
        source: 'Photo via Shutterstock',
        title: 'Trump vs DeSantis',
        type: 'image',
      },
    ],
    author: 'Navdeep Yadav',
    channels: [
      {
        name: 'News',
        tid: 57,
        vid: 1,
      },
      {
        name: 'Politics',
        tid: 16779,
        vid: 1,
      },
      {
        name: 'General',
        tid: 18467,
        vid: 1,
      },
    ],
    created: '2023-11-20T04:32:32Z',
    createdAt: '2023-11-20T04:32:32Z',
    id: 35866842,
    image: 'https://www.benzinga.com/files/images/story/2023/Trump-vs-DeSantis_0.png',
    isBzPost: true,
    isBzProPost: true,
    meta: {
      Author: null,
      Authors: [
        {
          name: '',
          uid: '0',
        },
      ],
      Ext: null,
      Flags: {
        AddGoogleStandoutMetaTag: false,
        ContributedContent: false,
        EvergreenContent: false,
        MediaSiteDNDOverride: false,
        SendToMSN: true,
        SendToRobinhood: true,
        SendToYahooFinance: false,
        ShowAdvertiserDisclosure: false,
        ShowCopyrightNotice: true,
      },
      Partner: null,
      PartnerTaxonomy: null,
      Reach: {
        Disclosure: {},
      },
      Reference: null,
      SEC: null,
      SectorV2: {},
      wp_post_meta: {
        campaign_strategy: 'Default',
        post_id: 145898,
        post_path: 'news/2023/11/20/ron-desantis-takes-a-swipe-at-donald-trump-father-time-is-undefeated',
        post_type: 'post',
      },
    },
    nodeId: 35866842,
    stocks: [],
    storyId: '655ae15d49547100018c4df6',
    tags: [
      {
        name: '2024 Presidential Race',
        tid: 847292,
        vid: 3,
      },
      {
        name: 'Donald Trump',
        tid: 18656,
        vid: 3,
      },
      {
        name: 'Ron DeSantis',
        tid: 519269,
        vid: 3,
      },
    ],
    teaser:
      'Florida&#39;s Governor, Ron DeSantis, took a swipe at Trump, voicing his concerns about the age of ex-President as the 2024 presidential election race heats up.',
    teaserText:
      'Florida&#39;s Governor, Ron DeSantis, took a swipe at Trump, voicing his concerns about the age of ex-President as the 2024 presidential election race heats up.',
    tickers: [],
    title:
      'Ron DeSantis Takes A Swipe At 2024 GOP Frontrunner: &#39;Father Time Is Undefeated. Donald Trump Is Not Exempt From Any Of That&#39;',
    updated: '2023-11-20T04:32:33Z',
    updatedAt: '2023-11-20T04:32:33Z',
    url: 'https://www.benzinga.com/news/23/11/35866842/ron-desantis-takes-a-swipe-at-2024-gop-frontrunner-father-time-is-undefeated-donald-trump-is-not-exe',
  },
];
